import React from 'react';

import { OrdCreate, OrdEdit, OrdShow } from '@ragu-components/ord-components';
import { Resources } from '@ragu-components/ord-resources';

import { GroupsForm } from './GroupsForm';

import type { OrdResourceProps } from '@ragu-components/ord-resources';
import type { RoleRead } from '@ragu-components/ord-types';

const RolesList = React.lazy(async () => import('./GroupsList'));

export const rolesResource: OrdResourceProps = {
  key: Resources.roles,
  name: Resources.roles,
  list: <RolesList />,
  create: (
    <OrdCreate redirect='list'>
      <GroupsForm />
    </OrdCreate>
  ),
  edit: (
    <OrdEdit redirect='list'>
      <GroupsForm />
    </OrdEdit>
  ),
  show: (
    <OrdShow>
      <GroupsForm />
    </OrdShow>
  ),
  options: {},
  recordRepresentation: (record: RoleRead): string => record.name,
};
